<template>
  <div class="main">
    <!-- title -->
    <div class="subTitle">
      <el-link
        icon="el-icon-arrow-left"
        :underline="false"
        href="#/clientManagement"
        >Client Management</el-link
      >
    </div>
    <h3 class="title" content="edit" placement="bottom">Edit Account</h3>
    <div class="detailContent">
      <div class="requireRmarks">*Required Fields</div>
      <el-form
        label-width="50%"
        label-position="left"
        ref="formAccount"
        :model="formAccount"
        :rules="formAccountRules"
      >
        <el-row>
          <h4>Profile</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Client ID" prop="clientID">
              <p>{{ formAccount.clientID }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formAccount.userStatus != 'OPENED'">
            <el-form-item label="Username" prop="UserName">
              <p>{{ formAccount.userName }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              v-if="formAccount.isDummyUser"
              label="Last Name"
              prop="lastName"
              :error="formAccount.lastName ? '' : 'Last Name cannot be empty'"
            >
              <el-input
                v-model="formAccount.lastName"
                maxlength="50"
              ></el-input>
            </el-form-item>

            <el-form-item v-else label="Last Name">
              <p>{{ formAccount.lastName ? formAccount.lastName : "-" }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="First Name" prop="firstName">
              <el-input
                v-model="formAccount.firstName"
                maxlength="50"
                v-if="formAccount.isDummyUser"
              ></el-input>
              <p v-else>
                {{ formAccount.firstName ? formAccount.firstName : "-" }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              label="Date Of Birth"
              prop="dob"
              v-if="formAccount.isDummyUser"
            >
              <el-date-picker
                style="width: 100%"
                v-model="formAccount.dob"
                type="date"
                format="yyyy/MM/dd"
                placeholder="Date of Birth"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Date Of Birth" v-else>
              <p>
                {{
                  formAccount.dob
                    ? $commonjs.paramFormatDate(formAccount.dob, true)
                    : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="ITIN" prop="ITIN">
              <p>{{ formAccount.itin ? formAccount.itin : "-" }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="ITN" prop="ITN">
              <p>{{ formAccount.itn ? formAccount.itn : "-" }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <h4>General information</h4>
        </el-row>
        <div class="border-box">
          <el-row :gutter="50">
            <el-col :span="12" v-if="!formAccount.isDummyUser">
              <el-form-item
                label="Salesforce Email address"
                prop="salesforceEmail"
              >
                <p>
                  {{
                    formAccount.salesforceEmail
                      ? formAccount.salesforceEmail
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Mobile Phone" prop="phone">
                <p>
                  {{
                    formAccount.cellularphone ? formAccount.cellularphone : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Residency">
                <p>
                  {{ formAccount.residencyID ? formAccount.residencyID : "-" }}
                </p>
                <!-- <el-select v-model="formAccount.region">
                  <el-option
                    v-for="(item, index) in regionList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Preferred Language"
                prop="salesforceLanguage"
              >
                <p>
                  {{
                    formAccount.salesforceLanguage
                      ? formAccount.salesforceLanguage
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Citizenship" prop="Citizenship">
                {{ formAccount.citizenship ? formAccount.citizenship : "-" }}
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <h4>Correspondence Address</h4>
        </el-row>
        <div class="border-boxshadow">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Correspondence Address"
                prop="Correspondence Address"
              >
                {{ formAccount.addressLine1 ? formAccount.addressLine1 : "-" }}
                <br />
                {{ formAccount.addressLine2 ? formAccount.addressLine2 : " " }}
                <br />
                {{ formAccount.addressLine3 ? formAccount.addressLine3 : " " }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="City" prop="City">
                {{ formAccount.city ? formAccount.city : "-" }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Country " prop="Country ">
                {{ formAccount.countryDesc ? formAccount.countryDesc : "-" }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Province " prop="Province ">
                {{ formAccount.province ? formAccount.province : "-" }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Postal Code" prop="Postal Code">
                {{ formAccount.postalCode ? formAccount.postalCode : "-" }}
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="border-boxshadow">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="National ID" prop="National ID">
                <div v-if="formAccount.nationalId">
                  <el-button
                    style="width: 100%"
                    @click="getPassportlink(formAccount.nationalId)"
                    >View</el-button
                  >
                </div>

                <div v-else>-</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Passport" prop="Passport">
                <div v-if="formAccount.passport">
                  <el-button
                    style="width: 100%"
                    @click="getPassportlink(formAccount.passport)"
                    >View</el-button
                  >
                </div>

                <div v-else>-</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="UpdateProfileLatestStatus  " prop="">
                <p>
                  {{
                    formAccount.userUpdateProfileLatestStatus === -1
                      ? "REJECT"
                      : formAccount.userUpdateProfileLatestStatus === 0
                      ? "PENDING"
                      : formAccount.userUpdateProfileLatestStatus === 1
                      ? "APPROVED"
                      : formAccount.userUpdateProfileLatestStatus === 9
                      ? "INVALID"
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <h4>Setting</h4>
        </el-row>
        <div class="border-boxshadow">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Market Updates" prop="Market updates">
                {{
                  formAccount.marketUpdates ? formAccount.marketUpdates : "-"
                }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Corporate" prop="Corporate">
                {{ formAccount.corporate ? formAccount.corporate : "-" }}
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <h4>Sales Information</h4>
        </el-row>
        <div class="border-boxshadow">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Sales Office" prop="Sales Office">
                {{ formAccount.salesOffice ? formAccount.salesOffice : "-" }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Region">
                {{
                  formAccount.salesforceRegion
                    ? formAccount.salesforceRegion
                    : "-"
                }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Sales Representative Name"
                prop="Sales Representative name"
              >
                <p>{{ formAccount.representativeName }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Servicing Channel Type"
                prop="salseforceServicingChannelType"
              >
                <p>{{ formAccount.salseforceServicingChannelType }}</p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Referral Company / Individual Planner"
                prop="salseforceServicingChannelName"
              >
                <p>{{ formAccount.salseforceServicingChannelName }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Referral Planner / Broker"
                prop="salseforceServicingFinancialPlanner"
              >
                <p>{{ formAccount.salseforceServicingFinancialPlanner }}</p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Sub-Referral Company"
                prop="salseforceReferredByIfa"
              >
                <p>{{ formAccount.salseforceReferredByIfa }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Sub-Referral Planner"
                prop="salseforceReferredByPlanner"
              >
                <p>{{ formAccount.salseforceReferredByPlanner }}</p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Referred by (Client Lv)"
                prop="salseforceReferredByClientLv"
              >
                <p>{{ formAccount.salseforceReferredByClientLv }}</p>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <h4>Documents</h4>
        </el-row>
        <div class="border-boxshadow">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Investment Summary"
                prop="Investment Summary"
              >
                <el-button
                  style="width: 100%"
                  @click="handleInvestment('pdl_activeProjects', false)"
                  >View</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="My Documents" prop="My Documents">
                <el-button style="width: 100%" @click="handleDocuments()"
                  >View</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50" v-if="this.formAccount.statement">
            <el-col :span="12">
              <el-form-item
                label="Investor Statement"
                prop="Investor Statement"
              >
                <el-button style="width: 100%" @click="download()"
                  >Download</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <h4>Booklet</h4>
        </el-row>
        <div class="border-boxshadow">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="English" prop="English">
                <p style="word-break: break-all">
                  {{ formAccount.booklets.EN ? formAccount.booklets.EN : "-" }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Traditional Chinese"
                prop="Traditional Chinese"
              >
                <p style="word-break: break-all">
                  {{
                    formAccount.booklets.ZH_HK
                      ? formAccount.booklets.ZH_HK
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Japanese" prop="Japanese">
                <p style="word-break: break-all">
                  {{ formAccount.booklets.JA ? formAccount.booklets.JA : "-" }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Simplified Chinese"
                prop="Simplified Chinese"
              >
                <p style="word-break: break-all">
                  {{
                    formAccount.booklets.ZH_CN
                      ? formAccount.booklets.ZH_CN
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <h4>Status</h4>
        </el-row>
        <div class="border-boxshadow">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Last success login date & time"
                prop="lastLogin"
              >
                <p>
                  {{
                    formAccount.lastLogin
                      ? $commonjs.paramFormatDate(formAccount.lastLogin)
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Last password update date & time"
                prop="lastPwd"
              >
                <p>
                  {{
                    formAccount.lastPwd
                      ? $commonjs.paramFormatDate(formAccount.lastPwd)
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Account Status" prop="userStatus">
                <p
                  :style="
                    formAccount.userStatus == 'ACTIVATED'
                      ? 'color:rgb(0,127,80)'
                      : formAccount.userStatus == 'OPENED'
                      ? 'color:rgb(85,130,160)'
                      : 'color:rgb(255,0,0)'
                  "
                >
                  {{ $commonjs.userStatusMap(formAccount.userStatus) }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Activation Date & Time" prop="activationAt">
                <p>
                  {{
                    formAccount.activationAt
                      ? $commonjs.paramFormatDate(formAccount.activationAt)
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Remarks"
                prop="remarks"
                v-if="formAccount.userStatus != 'OPENED'"
              >
                <el-input
                  v-model="formAccount.remarks"
                  maxlength="100"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Profile Status">
                <p>
                  {{
                    formAccount.userUpdateProfileLatestStatus === -1
                      ? "REJECT"
                      : formAccount.userUpdateProfileLatestStatus === 0
                      ? "PENDING"
                      : formAccount.userUpdateProfileLatestStatus === 1
                      ? "APPROVED"
                      : formAccount.userUpdateProfileLatestStatus === 9
                      ? "INVALID"
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <!-- <el-form
        label-width="50%"
        label-position="left"
        ref="formAccount"
        :model="formAccount"
        :rules="formAccountRules"
      >
        <el-row>
          <h4>Personal Information</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Client ID" prop="clientID">
              <p>{{ formAccount.clientID }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formAccount.userStatus != 'OPENED'">
            <el-form-item label="Username" prop="userName">
              <p>{{ formAccount.userName }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50" v-if="formAccount.isDummyUser">
          <el-col :span="12">
            <el-form-item label="Dummy account type" prop="userType">
              <p>{{ $commonjs.userTypeMap(formAccount.userType) }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Dummy account remarks" prop="userTypeRemarks">
              <el-input
                v-model="formAccount.userTypeRemarks"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              v-if="formAccount.isDummyUser"
              label="Last Name"
              prop="lastName"
              :error="formAccount.lastName ? '' : 'Last Name cannot be empty'"
            >
              <el-input
                v-model="formAccount.lastName"
                maxlength="50"
              ></el-input>
            </el-form-item>

            <el-form-item v-else label="Last Name">
              <p>{{ formAccount.lastName ? formAccount.lastName : "-" }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="First Name" prop="firstName">
              <el-input
                v-model="formAccount.firstName"
                maxlength="50"
                v-if="formAccount.isDummyUser"
              ></el-input>
              <p v-else>
                {{ formAccount.firstName ? formAccount.firstName : "-" }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Middle Name" prop="middleName">
              <el-input
                v-model="formAccount.middleName"
                maxlength="50"
                v-if="formAccount.isDummyUser"
              ></el-input>
              <p v-else>
                {{ formAccount.middleName ? formAccount.middleName : "-" }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Date Of Birth"
              prop="dob"
              v-if="formAccount.isDummyUser"
            >
              <el-date-picker
                style="width: 100%"
                v-model="formAccount.dob"
                type="date"
                format="yyyy/MM/dd"
                placeholder="Date of Birth"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Date Of Birth" v-else>
              <p>
                {{
                  formAccount.dob
                    ? $commonjs.paramFormatDate(formAccount.dob, true)
                    : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Mobile Phone" prop="phone">
              <p>
                {{
                  formAccount.cellularphone ? formAccount.cellularphone : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!formAccount.isDummyUser">
            <el-form-item label="Email Address" prop="salesforceEmail">
              <p>
                {{
                  formAccount.salesforceEmail
                    ? formAccount.salesforceEmail
                    : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <h4>Sales Information</h4>
        </el-row>
        <div v-if="formAccount.isDummyUser">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Sales Office*" prop="salesOffice">
                <el-select
                  v-model="formAccount.salesOffice"
                  @change="changeSalesOffice"
                  :disabled="$store.state.userLevel >= 2"
                >
                  <el-option
                    v-for="(item, index) in salesOfficeList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Region" prop="region">
                <el-select v-model="formAccount.region">
                  <el-option
                    v-for="(item, index) in regionList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Sales Representative Name"
                prop="representativeName"
              >
                <el-input v-model="formAccount.representativeName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Sales Office">
                <p>{{ $commonjs.salesOfficeMap(formAccount.salesOffice) }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Salesforce Region">
                <p>
                  {{
                    formAccount.salesforceRegion
                      ? formAccount.salesforceRegion
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Region">
                <p>{{ $commonjs.regionMap(formAccount.region) }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Sales Representative Name">
                <p>{{ formAccount.representativeName }}</p>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Servicing Channel Type"
                prop="salseforceServicingChannelType"
              >
                <p>{{ formAccount.salseforceServicingChannelType }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Referral Company / Individual Planner"
                prop="salseforceServicingChannelName"
              >
                <p>{{ formAccount.salseforceServicingChannelName }}</p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Referral Planner / Broker"
                prop="salseforceServicingFinancialPlanner"
              >
                <p>{{ formAccount.salseforceServicingFinancialPlanner }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Sub-Referral Company"
                prop="salseforceReferredByIfa"
              >
                <p>{{ formAccount.salseforceReferredByIfa }}</p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Sub-Referral Planner"
                prop="salseforceReferredByPlanner"
              >
                <p>{{ formAccount.salseforceReferredByPlanner }}</p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Referred by (Client Lv)"
                prop="salseforceReferredByClientLv"
              >
                <p>{{ formAccount.salseforceReferredByClientLv }}</p>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="!formAccount.isDummyUser">
          <el-divider></el-divider>
          <el-row :gutter="50">
            <el-col :span="6">
              <h4>Investment Summary</h4>
            </el-col>
            <el-col :span="6">
              <el-button
                style="width: 100%"
                @click="handleInvestment('pdl_activeProjects', false)"
                >View</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div v-if="!formAccount.isDummyUser && formAccount.booklets">
          <el-divider></el-divider>
          <el-row>
            <h4>Booklet</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                :label="$commonjs.languageMap('EN')"
                prop="bookletEn"
              >
                <p style="word-break: break-all">
                  {{ formAccount.booklets.EN ? formAccount.booklets.EN : "-" }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$commonjs.languageMap('JA')"
                prop="bookletEn"
              >
                <p style="word-break: break-all">
                  {{ formAccount.booklets.JA ? formAccount.booklets.JA : "-" }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                :label="$commonjs.languageMap('ZH_CN')"
                prop="bookletEn"
              >
                <p style="word-break: break-all">
                  {{
                    formAccount.booklets.ZH_CN
                      ? formAccount.booklets.ZH_CN
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$commonjs.languageMap('ZH_HK')"
                prop="bookletEn"
              >
                <p style="word-break: break-all">
                  {{
                    formAccount.booklets.ZH_HK
                      ? formAccount.booklets.ZH_HK
                      : "-"
                  }}
                </p>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-divider></el-divider>
        <el-row>
          <h4>Language</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12" v-if="!formAccount.isDummyUser">
            <el-form-item label="Salesforce Preferred Language">
              <p>
                {{
                  formAccount.salesforceLanguage
                    ? formAccount.salesforceLanguage
                    : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Preferred Language" prop="preferredLanguage">
              <p>
                {{
                  formAccount.preferredLanguage
                    ? $commonjs.languageMap(formAccount.preferredLanguage)
                    : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <h4>Status</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              label="Last success login date & time"
              prop="lastLogin"
            >
              <p>
                {{
                  formAccount.lastLogin
                    ? $commonjs.paramFormatDate(formAccount.lastLogin)
                    : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Last password update date & time"
              prop="lastPwd"
            >
              <p>
                {{
                  formAccount.lastPwd
                    ? $commonjs.paramFormatDate(formAccount.lastPwd)
                    : "-"
                }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="User Status" prop="userStatus">
              <p
                :style="
                  formAccount.userStatus == 'ACTIVATED'
                    ? 'color:rgb(0,127,80)'
                    : formAccount.userStatus == 'OPENED'
                    ? 'color:rgb(85,130,160)'
                    : 'color:rgb(255,0,0)'
                "
              >
                {{ $commonjs.userStatusMap(formAccount.userStatus) }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Salesforce Status" prop="customerStatus">
              <p>{{ formAccount.customerStatus }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Last update by" prop="lastUpdate">
              <p>{{ formAccount.lastUpdate ? formAccount.lastUpdate : "-" }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Remarks"
              prop="remarks"
              v-if="formAccount.userStatus != 'OPENED'"
            >
              <el-input
                v-model="formAccount.remarks"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              label="User Activation Date & Time"
              prop="activationAt"
            >
              <p>{{ formAccount.activationAt }}</p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form> -->
    </div>
    <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
      <el-col :span="4">
        <el-button
          v-if="showSave"
          class="reset"
          style="width: 100%"
          @click="handleCancel"
          >Cancel</el-button
        >
      </el-col>
      <el-col :span="4" v-if="formAccount.userStatus != 'OPENED'">
        <el-button
          v-if="showSave"
          type="primary"
          style="width: 100%"
          @click="handleSave"
          >Save</el-button
        >
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="investmentPopup"
      width="1500px"
      :close-on-click-modal="false"
    >
      <div slot="title" style="width: 70%; margin: 0 auto" class="tabTitle">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" stretch>
          <el-tab-pane label="PDL" name="PDLI"></el-tab-pane>
          <el-tab-pane label="LOAN" name="LOAN"></el-tab-pane>
        </el-tabs>
      </div>
      <el-row
        :gutter="50"
        style="text-align: left; margin-top: -20px"
        v-if="activeTab == 'PDLI'"
      >
        <el-col :span="8">
          <h4
            style="
              font-size: 14px;
              color: rgb(0, 52, 72);
              font-weight: normal;
              margin: 0;
            "
          >
            Total Investment Amount
          </h4>
          <p style="font-size: 16px; color: rgb(0, 52, 72); font-weight: 600">
            {{
              "USD " +
              $commonjs.currenyFormat(formAccount.totalInvestmentAmount.USD) +
              " | " +
              "CAD " +
              $commonjs.currenyFormat(formAccount.totalInvestmentAmount.CAD)
            }}
          </p>
        </el-col>
        <el-col :span="8">
          <h4
            style="
              font-size: 14px;
              color: rgb(0, 52, 72);
              font-weight: normal;
              margin: 0;
            "
          >
            Gross Distribution Amount
          </h4>
          <p style="font-size: 16px; color: rgb(0, 52, 72); font-weight: 600">
            {{
              "USD " +
              $commonjs.currenyFormat(formAccount.totalDistributionAmount.USD) +
              " | " +
              "CAD " +
              $commonjs.currenyFormat(formAccount.totalDistributionAmount.CAD)
            }}
          </p>
        </el-col>
      </el-row>
      <el-row
        :gutter="50"
        style="text-align: left; margin-top: -20px"
        v-if="activeTab == 'LOAN'"
      >
        <el-col :span="8">
          <h4
            style="
              font-size: 14px;
              color: rgb(0, 52, 72);
              font-weight: normal;
              margin: 0;
            "
          >
            Total Loan Amount
          </h4>
          <p style="font-size: 16px; color: rgb(0, 52, 72); font-weight: 600">
            {{
              "USD " +
              $commonjs.currenyFormat(formAccount.totalLoanAmount.USD) +
              " | " +
              "CAD " +
              $commonjs.currenyFormat(formAccount.totalLoanAmount.CAD)
            }}
          </p>
        </el-col>
        <el-col :span="8">
          <h4
            style="
              font-size: 14px;
              color: rgb(0, 52, 72);
              font-weight: normal;
              margin: 0;
            "
          >
            Total Payment Amount
          </h4>
          <p style="font-size: 16px; color: rgb(0, 52, 72); font-weight: 600">
            {{
              "USD " +
              $commonjs.currenyFormat(formAccount.totalPaymentAmount.USD) +
              " | " +
              "CAD " +
              $commonjs.currenyFormat(formAccount.totalPaymentAmount.CAD)
            }}
          </p>
        </el-col>
      </el-row>
      <el-row :gutter="50" style="text-align: left">
        <el-col>
          <el-button
            round
            size="small"
            :class="subTabIndex == 0 ? 'activeTabButton' : 'TabButton'"
            @click="handleSubTab('activeProjects', 0)"
            >Active Projects</el-button
          >
          <el-button
            round
            size="small"
            :class="subTabIndex == 1 ? 'activeTabButton' : 'TabButton'"
            @click="handleSubTab('exitingProjects', 1)"
            v-if="activeTab == 'PDLI'"
            >Exiting Projects</el-button
          >
          <el-button
            round
            size="small"
            :class="subTabIndex == 2 ? 'activeTabButton' : 'TabButton'"
            @click="handleSubTab('exitedProjects', 2)"
            >Exited Projects</el-button
          >
        </el-col>
      </el-row>
      <el-table v-if="activeTab == 'PDLI'" :data="tableData" max-height="600px">
        <el-table-column prop="projectName" label="Project Name">
          <template slot-scope="scope">{{
            scope.row.projectName ? scope.row.projectName : "-"
          }}</template>
        </el-table-column>
        <el-table-column prop="location" label="Location">
          <template slot-scope="scope">{{
            scope.row.location ? scope.row.location : "-"
          }}</template>
        </el-table-column>
        <el-table-column prop="purchaseAmount" label="Purchase Amount">
          <template slot-scope="scope">{{
            $commonjs.currenyFormat(scope.row.purchaseAmount)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="purchaseDate"
          label="Last Purchase Date"
          :formatter="$commonjs.tableFormatDate"
          sortable
        ></el-table-column>
        <el-table-column
          v-if="showMore"
          prop="distributionAmount"
          label="Distribution Amount"
        >
          <template slot-scope="scope">{{
            scope.row.distributionAmount
              ? $commonjs.currenyFormat(scope.row.distributionAmount)
              : "-"
          }}</template>
        </el-table-column>
        <el-table-column
          v-if="showMore"
          prop="paymentDate"
          label="Last Payment Date"
          :formatter="$commonjs.tableFormatDate"
          sortable
        ></el-table-column>
        <el-table-column
          prop="dispositionStatus"
          label="Disposition Status"
        ></el-table-column>
      </el-table>
      <el-table v-else :data="tableData" max-height="600px">
        <el-table-column prop="projectName" label="Project Name">
          <template slot-scope="scope">{{
            scope.row.projectName ? scope.row.projectName : "-"
          }}</template>
        </el-table-column>
        <el-table-column prop="location" label="Location">
          <template slot-scope="scope">{{
            scope.row.location ? scope.row.location : "-"
          }}</template>
        </el-table-column>
        <el-table-column prop="initialInvestment" label="Original Principal">
          <template slot-scope="scope">{{
            $commonjs.currenyFormat(scope.row.initialInvestment)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="purchaseDate"
          label="Last Purchase Date"
          :formatter="$commonjs.tableFormatDate"
          sortable
        ></el-table-column>
        <el-table-column prop="purchaseAmount" label="Outstanding Balance">
          <template slot-scope="scope">{{
            $commonjs.currenyFormat(scope.row.purchaseAmount)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="paymentDate"
          label="Last Interest Cutoff Date"
          :formatter="$commonjs.tableFormatDate"
          sortable
        ></el-table-column>
        <el-table-column prop="distributionAmount" label="Total Distribution">
          <template slot-scope="scope">{{
            $commonjs.currenyFormat(scope.row.distributionAmount)
          }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :visible.sync="myDocuments"
      width="1500px"
      :close-on-click-modal="false"
      title="My Documents"
    >
      <el-divider></el-divider>
      <div>
        <el-row>
          <el-col :span="12">
            <div style="display: flex">
              <el-input
                v-model="searchData"
                @keyup.enter.native="submitSearch"
                maxlength="50"
              ></el-input>
              <el-button
                type="primary"
                class="search"
                style="margin-left: 10px"
                @click="
                  () => {
                    submitSearch();
                  }
                "
                >Apply</el-button
              >
              <el-button
                class="reset"
                @click="
                  () => {
                    clearSearch();
                  }
                "
                >Clear</el-button
              >
            </div>
          </el-col>
          <el-col :span="12">
            <div style="width: 100%; display: flex; justify-content: flex-end">
              <div style="padding-right: 10px">
                <el-dropdown
                  style="margin-bottom: 22px; margin-right: 20px"
                  trigger="click"
                  ref="filter"
                >
                  <span class="el-dropdown-link sortbox">
                    <em class="filter"></em>
                    Filter
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-form
                      ref="formFilter"
                      :model="formFilter"
                      style="width: 300px; padding: 14px 24px"
                    >
                      <el-form-item
                        label="Project Name"
                        style="margin-bottom: 12px"
                      >
                        <el-select
                          v-model="Products"
                          :popper-append-to-body="false"
                          filterable
                          multiple
                          clearable
                        >
                          <el-option
                            v-for="(item, index) in ProductsList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="Document Type"
                        style="margin-bottom: 12px"
                      >
                        <el-select
                          v-model="type"
                          :popper-append-to-body="false"
                          multiple
                          clearable
                        >
                          <el-option
                            v-for="(item, index) in typeList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="Document Date"
                        style="margin-bottom: 12px"
                      >
                        <div class="">
                          <el-date-picker
                            v-model="date"
                            type="date"
                            placeholder="option date"
                          >
                          </el-date-picker>
                        </div>
                      </el-form-item>
                      <!-- <el-form-item
                          label="Account Type"
                          style="margin-bottom: 12px"
                          prop="type"
                        >
                          <el-select
                            v-model="formFilter.type"
                            :popper-append-to-body="false"
                          >
                            <el-option value="All">All</el-option>
                            <el-option
                              v-for="(item, index) in userTypeList"
                              :key="index"
                              :label="item.name"
                              :value="item.code"
                            ></el-option>
                          </el-select>
                        </el-form-item> -->
                      <div class="filterButton">
                        <el-form-item
                          style="margin-right: 15px; margin-bottom: 0"
                        >
                          <el-button
                            class="reset"
                            @click="
                              $refs.filter.hide();
                              clearSearch();
                            "
                            >Reset</el-button
                          >
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0">
                          <el-button
                            type="primary"
                            class="search"
                            @click="
                              () => {
                                $refs.filter.hide();
                                filterSearch();
                              }
                            "
                            >Apply</el-button
                          >
                        </el-form-item>
                      </div>
                    </el-form>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown
                  style="margin-bottom: 22px"
                  trigger="click"
                  @command="handleCommand"
                >
                  <span class="el-dropdown-link sortbox">
                    <em class="sort"></em>
                    Sort by
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="'desc'"
                      >Creation Date (New - Old)</el-dropdown-item
                    >
                    <el-dropdown-item :command="'asc'"
                      >Creation Date (Old - New)</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </el-col>
        </el-row>
        <template>
          <el-table :data="documentsData" style="width: 100%">
            <el-table-column prop="productName" label="Project Name">
            </el-table-column>
            <el-table-column prop="description" label="Description" width="280">
            </el-table-column>
            <el-table-column
              prop="description"
              label="Document Type"
              width="280"
            >
            </el-table-column>
            <el-table-column
              prop="documentCreationDate"
              label="Document Date"
              width="280"
              :formatter="$commonjs.tableFormatDateTime"
            >
            </el-table-column>
            <el-table-column label="View" width="280">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  class="search"
                  @click="
                    () => {
                      viewbtn(scope.row.docNumber, scope.row.productName);
                    }
                  "
                  >View</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>

        <app-pagination
          @size-change="
            (v) => {
              currentSize = v;
              currentPage = 1;
              getDocuments();
            }
          "
          @current-change="
            (v) => {
              currentPage = v;
              getDocuments();
            }
          "
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :total="total"
          :page-size="currentSize"
        ></app-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  appUserDetail,
  getSalesOffice,
  getSalesRegion,
  appUserEdit,
  appInvestment,
  documents,
  appProducts,
  optionDocType,
  documentsDetail,
  documentsProjects,
  documentsType,
  getPassport,
} from "@/request/api";
export default {
  name: "editUser",
  data() {
    return {
      formAccountRules: this.$validation.appUserEdit,
      formAccount: {
        id: "",
        clientID: "",
        userName: "",
        userType: "",
        userTypeRemarks: "",
        firstName: "",
        lastName: "",
        middleName: "",
        dob: "",
        email: "",
        salesOffice: "",
        region: "",
        representativeName: "",
        salesforceLanguage: "",
        preferredLanguage: "",
        lastLogin: "",
        lastPwd: "",
        userStatus: "",
        remarks: "",
        lastUpdate: "",
        isDummyUser: false,
        customerStatus: "",
        activationAt: "",
        salseforceServicingChannelType: "",
        salseforceServicingChannelName: "",
        salseforceServicingFinancialPlanner: "",
        salseforceReferredByIfa: "",
        salseforceReferredByPlanner: "",
        salseforceReferredByClientLv: "",
        sfUserType: "",
        // loanInvestment:{},
        // pdlInvestment:{},
        totalInvestmentAmount: {},
        totalDistributionAmount: {},
        totalLoanAmount: {},
        totalPaymentAmount: {},
        pdl_activeProjects: [],
        pdl_exitedProjects: [],
        pdl_exitingProjects: [],
        loan_activeProjects: [],
        loan_exitedProjects: [],
        loan_exitingProjects: [],
      },
      salesOfficeList: [],
      regionList: [],
      langaugeList: [
        { name: "English", code: "EN" },
        { name: "Traditional Chinese", code: "ZH_HK" },
        { name: "Simplified Chinese", code: "ZH_CN" },
        { name: "Japanese", code: "JA" },
      ],
      documentsData: [],
      searchData: "",
      investmentPopup: false,
      myDocuments: false,
      tableData: [],
      showMore: false,
      activeTab: "PDLI",
      subTabIndex: 0,
      prevRoute: null,
      currentSize: 10,
      currentPage: 1,
      total: 0,
      sort: "",
      ProductsList: [],
      typeList: [],
      formFilter: [{ Products: "All" }, { type: "All" }, { date: "All" }],
      Products: [],
      type: [],
      date: null,
      showSave: true,
    };
  },
  methods: {
    getDetail() {
      appUserDetail(this.$route.params.id).then((res) => {
        let content = res.data.payload;
        this.formAccount.id = content.id;
        this.formAccount.clientID = content.clientID;
        this.formAccount.userName = content.username;
        this.formAccount.userType = content.userType;
        this.formAccount.email = content.email;
        this.formAccount.userTypeRemarks = content.userTypeRemark;
        this.formAccount.remarks = content.userStatusRemark;
        this.formAccount.customerStatus = content.customerStatus;
        this.formAccount.activationAt = content.activationAt;
        this.formAccount.firstName = content.firstName;
        this.formAccount.lastName = content.lastName;
        this.formAccount.middleName = content.middleName;
        this.formAccount.dob = content.dob;
        this.formAccount.salesOffice = content.salesOffice;
        this.formAccount.booklets = content.booklets;
        this.changeSalesOffice(content.salesOffice, () => {
          this.formAccount.region = content.region;
        });
        // this.formAccount.region = content.region;
        this.formAccount.representativeName = content.representative;
        this.formAccount.salesforceLanguage = content.salesforceLanguage;
        this.formAccount.salesforceEmail = content.salesforceEmail;
        this.formAccount.cellularphone = content.cellularphone;
        this.formAccount.salesforceOffice = content.salesforceOffice;
        this.formAccount.salesforceRegion = content.salesforceRegion;
        this.formAccount.preferredLanguage = content.language;
        this.formAccount.lastLogin = content.lastLoginAt;
        this.formAccount.lastPwd = content.lastPwdUpdatedAt;
        this.formAccount.userStatus = content.userStatus;
        this.formAccount.itin = content.itin;
        this.formAccount.itn = content.itn;
        this.formAccount.citizenship = content.citizenship;
        this.formAccount.addressLine1 = content.addressLine1;
        this.formAccount.addressLine2 = content.addressLine2;
        this.formAccount.addressLine3 = content.addressLine3;
        this.formAccount.residencyID = content.residencyID;
        this.formAccount.countryDesc = content.countryDesc;
        this.formAccount.city = content.city;
        this.formAccount.countryCode = content.countryCode;
        this.formAccount.province = content.province;
        this.formAccount.postalCode = content.postalCode;
        this.formAccount.nationalId = content.nationalId;
        this.formAccount.passport = content.passport;
        this.formAccount.statement = content.statement;

        var market = content.pushSettings.filter(
          (item) => item.notificationType === "MARKET"
        );
        this.formAccount.marketUpdates = market[0].isOn ? "ON" : "OFF";
        var corporate = content.pushSettings.filter(
          (item) => item.notificationType === "CORPORATE"
        );
        this.formAccount.corporate = corporate[0].isOn ? "ON" : "OFF";

        this.formAccount.lastUpdate =
          content.updatedByName != ""
            ? content.updatedByName +
              ", " +
              this.$commonjs.paramFormatDate(content.cmsUpdatedAt)
            : "";
        this.formAccount.isDummyUser = content.isDummyUser;
        this.formAccount.salseforceServicingChannelType =
          content.salseforceServicingChannelType
            ? content.salseforceServicingChannelType
            : "-";
        this.formAccount.salseforceServicingChannelName =
          content.salseforceServicingChannelName
            ? content.salseforceServicingChannelName
            : "-";
        this.formAccount.salseforceServicingFinancialPlanner =
          content.salseforceServicingFinancialPlanner
            ? content.salseforceServicingFinancialPlanner
            : "-";
        this.formAccount.salseforceReferredByIfa =
          content.salseforceReferredByIfa
            ? content.salseforceReferredByIfa
            : "-";
        this.formAccount.salseforceReferredByPlanner =
          content.salseforceReferredByPlanner
            ? content.salseforceReferredByPlanner
            : "-";
        this.formAccount.salseforceReferredByClientLv =
          content.salseforceReferredByClientLv
            ? content.salseforceReferredByClientLv
            : "-";
        this.formAccount.sfUserType = content.sfUserType;

        this.formAccount.userUpdateProfileLatestStatus =
          content.userUpdateProfileLatestStatus;
        // this.formAccount.loanInvestment = content.loanInvestment;
        // this.formAccount.pdlInvestment = content.pdlInvestment;

        // this.formAccount.totalInvestmentAmount = content.pdlInvestment.totalInvestmentAmount;
        // this.formAccount.totalDistributionAmount = content.pdlInvestment.totalDistributionAmount;
        // this.formAccount.totalLoanAmount = content.loanInvestment.totalLoanAmount;
        // this.formAccount.totalPaymentAmount = content.loanInvestment.totalPaymentAmount;
        // this.formAccount.pdl_activeProjects = content.pdlInvestment.activeProjects;
        // this.formAccount.pdl_exitedProjects = content.pdlInvestment.exitedProjects;
        // this.formAccount.pdl_exitingProjects = content.pdlInvestment.exitingProjects;
        // this.formAccount.loan_activeProjects = content.loanInvestment.activeProjects;
        // this.formAccount.loan_exitedProjects = content.loanInvestment.exitedProjects;
        // this.formAccount.loan_exitingProjects = content.loanInvestment.exitingProjects;
      });
    },

    showBtn(val) {
      console.log(this.$store.state.permissions);
      var permissions = this.$store.state.permissions.filter(
        (item) => item == val
      );
      if (!permissions[0]) {
        this.showSave = false;
      }
    },

    handleCommand(command) {
      console.log(command);
      this.sort = command;
      this.getDocuments();
    },

    submitSearch() {
      this.getDocuments();
    },

    filterSearch() {
      this.getDocuments();
    },
    clearSearch() {
      this.searchData = "";
      this.Products = "";
      this.type = "";
      this.date = "";

      this.getDocuments();
    },

    getProducts() {
      documentsProjects(this.$route.params.id).then((res) => {
        var option = [];
        res.data.map((item) => {
          option.push({ value: item.code, label: item.nameEn });
        });
        this.ProductsList = option;
      });
    },
    DocType() {
      documentsType(this.$route.params.id).then((res) => {
        var type = [];
        res.data.map((item) => {
          type.push({ value: item.code, label: item.name });
        });
        this.typeList = type;
      });
    },

    viewbtn(val, name) {
      console.log(val);
      documentsDetail(this.$route.params.id, val).then((res) => {
        console.log(res);
        if (res.data.message) {
          var bytes = this.base64ToArrayBuffer(res.data.message);
          this.saveByteArray(name, bytes);
        }
      });
    },

    getPassportlink(link) {
      let index = link.lastIndexOf("/appuser");
      link = link.substring(index + 1, link.length);
      console.log(link);
      getPassport(link).then((res) => {
        console.log(res);
        if (res.data.message) {
          var bytes = this.base64ToArrayBuffer(res.data.message);
          this.saveByteArray("Download", bytes);
        }
      });
    },

    base64ToArrayBuffer(base64) {
      console.log(base64);
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },

    saveByteArray(reportName, byte) {
      const link = document.createElement("a"); // 创建a标签
      const blob = new Blob([byte], {
        type: "application/pdf",
      }); // response就是接口返回的文件流
      const objectUrl = URL.createObjectURL(blob);
      link.href = objectUrl;
      link.download = reportName;
      link.click(); // 下载文件
      URL.revokeObjectURL(objectUrl);
    },

    getDocuments() {
      if (this.date) {
        var date = this.date.getFullYear() + "-";
        date += this.date.getMonth() + 1 + "-";
        date += this.date.getDate();
        this.date = date;
      }
      let data = {
        projectCodes: this.Products,
        productName: this.searchData,

        docType: this.type,
        date: this.date,

        offset: "DESC",
        size: this.currentSize,
        page: this.currentPage - 1,
        deviceModel: "WEB",
        entry: "WEB",
        isChina: false,
        sort: "documentCreationDate," + this.sort,
      };

      documents(this.$route.params.id, data).then((res) => {
        console.log(res);
        this.documentsData = res.data.content;
        this.total = res.data.totalElements;
      });
    },
    getFilterConfig() {
      getSalesOffice().then((res) => {
        this.salesOfficeList = res.data.payload;
      });
    },
    changeSalesOffice(v, callback) {
      this.clearRegion();
      getSalesRegion(v).then((res) => {
        this.regionList = res.data.payload;
        if (callback) callback();
      });
    },
    clearRegion() {
      this.regionList = [];
      this.$set(this.formAccount, "region", "");
    },
    handleCancel() {
      this.$router.push("/clientManagement");
    },
    handleSave() {
      this.$refs.formAccount.validate((valid) => {
        if (valid) {
          let params;
          if (this.formAccount.isDummyUser) {
            params = {
              clientID: this.formAccount.clientID,
              username: this.formAccount.userName,
              email: this.formAccount.email,
              userStatusRemark: this.formAccount.remarks,
              userTypeRemark: this.formAccount.userTypeRemarks,
              firstName: this.formAccount.firstName,
              lastName: this.formAccount.lastName,
              middleName: this.formAccount.middleName,
              dob: this.$commonjs.paramFormatDate(this.formAccount.dob, true),
              // salesforceLanguage:this.formAccount.salesforceLanguage,
              salesOffice: this.formAccount.salesOffice,
              region: this.formAccount.region,
              representative: this.formAccount.representativeName,
              sfUserType: this.formAccount.sfUserType,
            };
          } else {
            params = {
              clientID: this.formAccount.clientID,
              // username:this.formAccount.userName,
              email: this.formAccount.email,
              userStatusRemark: this.formAccount.remarks,
              sfUserType: this.formAccount.sfUserType,
            };
            if (this.formAccount.userStatus !== "OPENED")
              params["username"] = this.formAccount.userName;
          }
          appUserEdit(this.formAccount.clientID, params).then((res) => {
            console.log(res);
            if (res.data.status == "00") {
              this.$message.success("The changes have been saved");
              // this.getDetail();
              this.$router.push({
                name: "appUser",
                params: {
                  update: true,
                },
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          this.$message.error(
            "Please check the form and fill in correct format"
          );
        }
      });
    },
    handleInvestment(name, showMore) {
      this.activeTab = "PDLI";
      this.subTabIndex = 0;
      this.getInvestment(() => {
        this.investmentPopup = true;
        this.tableData = this.formAccount[name];
        this.showMore = showMore;
      });
    },
    handleDocuments() {
      this.myDocuments = true;
    },

    download() {
      if (this.formAccount.statement) {
        window.open(this.formAccount.statement);
      }
    },
    handleTabClick() {
      console.log(this.activeTab);
      this.getInvestment();
      this.subTabIndex = 0;
      if (this.activeTab == "PDLI") {
        if (this.subTabIndex == 0) {
          this.showMore = false;
        } else {
          this.showMore = true;
        }
      } else {
        this.showMore = true;
      }
    },
    getInvestment(callback) {
      appInvestment(this.$route.params.id, this.activeTab).then((res) => {
        console.log(res);
        if (res.data.status == "00") {
          let content = res.data.payload;
          this.formAccount.totalInvestmentAmount =
            content.totalInvestmentAmount;
          this.formAccount.totalDistributionAmount =
            content.totalDistributionAmount;
          this.formAccount.totalLoanAmount = content.totalLoanAmount;
          this.formAccount.totalPaymentAmount = content.totalPaymentAmount;
          if (this.activeTab == "PDLI") {
            this.formAccount.pdl_activeProjects = content.activeProjects;
            this.formAccount.pdl_exitedProjects = content.exitedProjects;
            this.formAccount.pdl_exitingProjects = content.exitingProjects;
            this.tableData = this.formAccount.pdl_activeProjects;
          } else {
            this.formAccount.loan_activeProjects = content.activeProjects;
            this.formAccount.loan_exitedProjects = content.exitedProjects;
            this.formAccount.loan_exitingProjects = content.exitingProjects;
            this.tableData = this.formAccount.loan_activeProjects;
          }
        } else {
          this.$message.error(res.data.msg);
        }
        if (callback) callback();
      });
    },
    handleSubTab(name, index) {
      this.subTabIndex = index;
      if (this.activeTab == "PDLI") {
        if (index == 0) {
          this.showMore = false;
        } else {
          this.showMore = true;
        }
        this.tableData = this.formAccount["pdl_" + name];
      } else {
        this.showMore = true;
        this.tableData = this.formAccount["loan_" + name];
      }
    },
  },
  created: function () {
    this.$commonjs.initRegionsMap();
    this.getDetail();
    this.getFilterConfig();
    this.getDocuments();
    this.getProducts();
    this.DocType();
    this.showBtn("APP_USER_WRITE");
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== "appUser") {
      this.prevRoute.meta.keepAlive = false;
    }
    next();
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}

.TabButton {
  background: rgb(247, 247, 249);
  color: rgb(85, 130, 160);
  border: 1px solid rgb(247, 247, 249);
}
.activeTabButton {
  background: rgb(85, 130, 160);
  color: #fff;
  border: 1px solid rgb(85, 130, 160);
}
.border-box {
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.border-boxshadow {
  padding: 20px;
  margin-bottom: 30px;
  border: 1px solid rgba(219, 223, 227, 0.3);
  box-shadow: 0px 0px 4px 1px rgb(0 0 0 / 50%);
}
.sortbox {
  cursor: pointer;
}
.filterButton {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/appUser/editUser.vue